export var brandTheme = {
  baseStyle: {
    display: 'inline-flex',
    height: '24px',
    width: 'fit-content',
    justifyContent: 'center'
  }
};
//# sourceMappingURL=Brand.theme.js.map